import { Can } from "./Can";
export * from "./useAuthorizedRoutes";
export * from "./config/ability";
export * from "./AuthorizationComponent";
export default Can;
